import { defineAction } from '~/prix'
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'
import generalGlobalSearchAction from './generalGlobalSearch.action.json' with { type: 'json' }

const generalGlobalSearchDefinition = defineAction({
  ...generalGlobalSearchAction,

  input: z.object({
    sourceFilter: z.string(),
    limit: z.number().min(1).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      title: 'Título',
      observation: 'Observação',
    }).nullish(),
    order: enumerated({
      asc: 'Ascendente',
      desc: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
    removeSourceBy: z
      .array(
        enumerated({
          alert: 'alert',
          community: 'community',
          residence: 'residence',
          citizen: 'citizen',
          pointOfInterest: 'pointOfInterest',
        }),
      )
      .nullish(),
  }),
  output: z.object({ items: z.array(z.object({})) }),
})

export default generalGlobalSearchDefinition
